// Sentry 이벤트 필터 — 프리 tier(월 5천) 보호용.
// 브라우저 확장, 크로스오리진 스크립트 에러, Next.js 내부 throw 등 무시.

import type { ErrorEvent, EventHint } from "@sentry/nextjs";

const NOISE_PATTERNS = [
  // 브라우저 확장·외부 스크립트
  /ResizeObserver loop/i,
  /Non-Error promise rejection captured/i,
  /^Script error\.?$/i,
  /extension context invalidated/i,
  /moz-extension:/i,
  /chrome-extension:/i,
  /safari-extension:/i,
  /Cannot redefine property/i,

  // 사용자 중단 (네비게이션 도중 fetch abort)
  /AbortError/i,
  /The operation was aborted/i,
  /The user aborted a request/i,

  // Node.js HTTP — 클라이언트가 연결을 끊었을 때 서버에서 발생 (normal disconnect)
  // stack: abortIncoming → socketOnClose → Socket.emit
  /^Error: aborted$/,
  /abortIncoming/,

  // Next.js 내부 제어 throw (에러가 아님)
  /NEXT_NOT_FOUND/,
  /NEXT_REDIRECT/,

  // 네트워크 일시 오류
  /NetworkError when attempting to fetch/i,
  /Failed to fetch/i,
  /Load failed/i,
];

export function filterNoise(event: ErrorEvent, hint: EventHint): ErrorEvent | null {
  const msgCandidates: string[] = [];

  const original = hint?.originalException;
  if (original instanceof Error) {
    msgCandidates.push(original.message, original.name);
  } else if (typeof original === "string") {
    msgCandidates.push(original);
  }
  if (event.message) msgCandidates.push(event.message);
  for (const ex of event.exception?.values ?? []) {
    if (ex.value) msgCandidates.push(ex.value);
    if (ex.type) msgCandidates.push(ex.type);
  }

  for (const m of msgCandidates) {
    if (!m) continue;
    for (const p of NOISE_PATTERNS) {
      if (p.test(m)) return null;
    }
  }
  return event;
}
